module.exports = __webpack_public_path__ + "img/head-first-line.6140e4a0.png";